import React, { memo } from "react";
import Icon from "../../../assets/icons/Icon";

const getButtonText = (children) => {
  if (typeof children === "string" || typeof children === "number") {
    return String(children).trim();
  }

  if (Array.isArray(children)) {
    return children
      .map((child) => getButtonText(child))
      .filter(Boolean)
      .join(" ")
      .trim();
  }

  if (React.isValidElement(children)) {
    return getButtonText(children.props?.children);
  }

  return "";
};

const Button = ({
  className,
  children,
  btnName = "",
  icon = null,
  type = "",
  isDisabled = false,
  onClick,
  isHidden = false,
  id = "",
  ...props
}) => {
  const buttonName = btnName || getButtonText(children);
  const resolvedTitle = props.title ?? buttonName ?? undefined;
  const resolvedAriaLabel = props["aria-label"] ?? buttonName ?? undefined;

  return (
    <button
       className={`${className} ${
    isDisabled ? "cursor-not-allowed" : "cursor-pointer"
  }`}
      type={type}
      disabled={isDisabled}
      onClick={onClick}
      hidden={isHidden}
      id={id}
      title={resolvedTitle}
      aria-label={resolvedAriaLabel}
      {...props}
    >
      {children}
      {icon ? <Icon name={icon} /> : null}
    </button>
  );
};

export default memo(Button);
